<template>
  <fragment>
        <div class="form-group flutuante col-12">
          <p>https://www.cdlbh.com.br/produto/centro-de-convencoes-cdl-bh/</p>
        </div>
  </fragment>
</template>

<script>
export default {
  name: "centroConvencoes",

  created() {
    if (this.$route.path == "/produto/centroConvencoes") {
      window.open("https://www.cdlbh.com.br/produto/centro-de-convencoes-cdl-bh/", "_blank");
      window.location.href = "/";
    }
  },
};
</script>

<style lang="scss" scoped>
.result {
  padding: 40px;
  max-height: 500px;
  overflow-y: auto;
}
</style>
